import { filterState } from './postFilters';

const loadMore = () => {
    const loadMoreButton = document.getElementById('posts-load-more');
    const loader = document.getElementById('loader');

    if (!loadMoreButton) {
        return;
    }

    const parseDataAttrs = (button) => {
        return {
            next: button.getAttribute('data-next'),
            type: button.getAttribute('data-type'),
            perPage: button.getAttribute('data-per-page'),
            categories: button.getAttribute('data-categories'),
            contentTypes: button.getAttribute('data-content-types')
        };
    };

    const buildQueryString = (params) => {
        return Object.keys(params)
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
            .join('&');
    };


    const handleLoadMoreClick = async (e) => {
        e.preventDefault();

        const data = parseDataAttrs(loadMoreButton);

        // Include current filter state if they exist
        data['categories'] = filterState.categories.length ? filterState.categories : data.categories;
        data['content-types'] = filterState.contentTypes.length ? filterState.contentTypes : data.contentTypes;

        const queryString = buildQueryString(data);

        try {
            loader.style.display = 'block';
            loadMoreButton.disabled = true;

            const response = await fetch(`${wpApiSettings.root}systal/v1/posts?${queryString}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const result = await response.json();

            if (result.html) {
                document.getElementById('posts-grid').insertAdjacentHTML('beforeend', result.html);
            }
            if (result.more_posts) {
                loadMoreButton.setAttribute('data-next', parseInt(data.next, 10) + 1);
                loadMoreButton.disabled = false;
            } else {
                loadMoreButton.disabled = true;
            }
        } catch (error) {
            console.error('Error loading more posts:', error);
            loadMoreButton.disabled = true;
        } finally {
            loader.style.display = 'none';
        }
    };

    loadMoreButton.addEventListener('click', handleLoadMoreClick);
};

export default loadMore;
